module.exports = __webpack_public_path__ + "img/bs_banner_en.997fb501.jpg";